// src/utils/jsonSafe.js
export const safeParseArray = (s) => {
  try {
    const a = JSON.parse(s || "[]");
    return Array.isArray(a) ? a : [];
  } catch {
    return [];
  }
};

export const safeParseObject = (s) => {
  try {
    const o = JSON.parse(s || "{}");
    return o && typeof o === "object" && !Array.isArray(o) ? o : {};
  } catch {
    return {};
  }
};

export const compactIntegerMap = (obj = {}) =>
  Object.fromEntries(
    Object.entries(obj).filter(([_, v]) => Number.isInteger(v))
  );
